// @file get current user info
import { ww } from 'bits/global'

let userHelpers = {
  isAdmin() {
    return ['owner', 'admin', 'teacher'].indexOf(this.role) > -1
  },
  isOwner() {
    return this.role === 'owner'
  },
}

let currentUser = window.$currentUser
if (!currentUser) {
  if (ww && ww.xstore) {
    currentUser = ww.xstore.state.user
  }
}

if (!currentUser && ww && ww.vueStartingState) {
  currentUser = ww.vueStartingState.user
}

if (!currentUser) {
  currentUser = { id: null }
}
export default Object.assign(userHelpers, currentUser)
